import React, { createContext, type PropsWithChildren } from 'react';

import type {
	ChoreographerAssetsContext,
	ChoreographerAssetsContextProviderProps,
} from './__types__/ChoreographerAssetsContext.ts';
import { useChoreographerServices } from './useChoreographerServices.ts';
import type { ChoreographerFactory } from '@atlassian/ipm-choreographer/factory/types';

const Context: React.Context<ChoreographerFactory | undefined> = createContext<
	ChoreographerAssetsContext | undefined
>(undefined);
const Consumer: React.Consumer<ChoreographerFactory | undefined> = Context.Consumer;
const Provider: React.Provider<ChoreographerFactory | undefined> = Context.Provider;

export const ChoreographerAssetsContextProvider = ({
	children,
}: PropsWithChildren<ChoreographerAssetsContextProviderProps>): React.JSX.Element => {
	const choreographerFactoryAssets = useChoreographerServices();

	return <Provider value={choreographerFactoryAssets}>{children}</Provider>;
};

export { Consumer, Context, ChoreographerAssetsContextProvider as Provider };
